export default __webpack_public_path__ + "recenter-960-8984f0cda1ed958f9168c6a8f82b6f17.webp";